import initApp from './initApp'
import userStore from './stores/user'

userStore.init().then(initApp, initApp)
